export default __webpack_public_path__ + "static/media/qukes-funny-face-animal-sandwiches.45094bde.jpg";